import { Navigate, useParams } from '@rocketlane/rocket-router';
import { RoutePaths } from 'constant';

export const LegacySignalsAiAnalyticsConversationRedirect = () => {
  const { conversationId } = useParams<{ conversationId: string }>();

  return (
    <Navigate
      replace
      to={`${RoutePaths.customerPorfolioSignalsAiAnalytics}/${conversationId}`}
    />
  );
};

export const LegacySignalsAiAnalyticsIndexRedirect = () => (
  <Navigate replace to={RoutePaths.customerPorfolioSignals} />
);
